export default "__VITE_ASSET__DgF7RGqy__"